module.exports = __webpack_public_path__ + "static/media/header-bg.5e7ac0fb.png";